// Reflect whether any drawer is open on <body>, so the home view can push left.
function syncPanelOpen() {
  document.body.classList.toggle('panel-open', !!document.querySelector('.modal-backdrop.open'));
}

export function openBackdrop(id) { document.getElementById(id).classList.add('open'); syncPanelOpen(); }
export function closeBackdrop(id) { document.getElementById(id).classList.remove('open'); syncPanelOpen(); }

document.querySelectorAll('[data-close-modal]').forEach(btn => {
  btn.addEventListener('click', () => closeBackdrop(btn.dataset.closeModal));
});
document.querySelectorAll('.modal-backdrop').forEach(bd => {
  bd.addEventListener('click', (e) => {
    if (e.target === bd) { bd.classList.remove('open'); syncPanelOpen(); }
  });
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.modal-backdrop.open').forEach(bd => bd.classList.remove('open'));
    syncPanelOpen();
  }
});
